import { useCallback, useMemo, useState } from 'react';
import { Platform } from 'react-native';

const NOOP_PROPS = {};

/**
 * Hover tracking for web pointers, inert everywhere else. Built on
 * onPointerEnter/onPointerLeave so it works on TouchableOpacity and plain
 * Views without migrating them to Pressable. Spread `hoverProps` onto the
 * element and branch styles on `hovered`:
 *
 *   const { hovered, hoverProps } = useWebHover();
 *   <TouchableOpacity {...hoverProps}
 *     style={[base, hovered && { backgroundColor: colors.hoverSurface }]} />
 */
export function useWebHover(enabled = true) {
  const [hovered, setHovered] = useState(false);
  const onPointerEnter = useCallback(() => setHovered(true), []);
  const onPointerLeave = useCallback(() => setHovered(false), []);

  const active = Platform.OS === 'web' && enabled;
  const hoverProps = useMemo(
    () => (active ? { onPointerEnter, onPointerLeave } : NOOP_PROPS),
    [active, onPointerEnter, onPointerLeave]
  );

  return { hovered: active && hovered, hoverProps };
}
